import React from 'react';
import { ShieldCheck } from 'lucide-react';

export const EmptyChatView = () => (
  <div className="flex-1 flex items-center justify-center" style={{ backgroundColor: '#05050A' }}>
    <div className="text-center">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary/10 mb-6">
        <ShieldCheck className="w-8 h-8 text-primary" />
      </div>
      <h2 className="text-xl font-semibold text-white mb-2">Welcome to Government Shield</h2>
      <p className="text-slate-400 max-w-sm">
        Select a conversation or start a new chat to begin encrypted messaging
      </p>
    </div>
  </div>
);
